// @flow
import Vue from 'vue'

const engravedId = function (value: string) {
  if (value.length === 16) {
    return value.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1.$2.$3.$4')
  }
  return value
}

Vue.filter('engravedId', engravedId)

export default engravedId



// WEBPACK FOOTER //
// ./src/filters/engraved-id.js